import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionContractInfo } from "../actionContractInfo";
export var epicContractFinishCooldown = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.FinishCooldown), switchMap(function (action) {
        var contractData = {
            cooldownTime: 0,
        };
        utilPersistence.setValue(IdPersistence.ContractData, contractData);
        return [];
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractFinishCooldown.ts
// module id = 1989
// module chunks = 3